import React, { useCallback } from "react";
import { AHIcon, Box, ListItem } from "arkh";
import { ItemButton, ItemButtonTitle } from "./ItemButton";
import { useListContentStyle } from "../../../components/mobile/useListContentStyle";
import { FormattedMessage } from "react-intl";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";

export const RoutineEditChecklistSectionFooter = ({
  newTaskId,
  sectionId,
  index,
  onCreateTask,
  onAddExistingTask,
  onOrderTasks,
}: {
  newTaskId: string;
  sectionId: string;
  index: number;
  onCreateTask(_: { taskId: string; sectionId: string; index: number }): void;
  onAddExistingTask?(sectionId: string): void;
  onOrderTasks?(sectionId: string): void;
}) => {
  const intl_tokens = useIntlTokens();
  const listContentStyle = useListContentStyle();
  const onPressOrderTasks = useCallback(() => {
    onOrderTasks?.(sectionId);
  }, [onOrderTasks, sectionId]);
  const onPresAddExistingTask = useCallback(() => {
    onAddExistingTask?.(sectionId);
  }, [onAddExistingTask, sectionId]);
  const onPressCreateTask = useCallback(() => {
    onCreateTask({ taskId: newTaskId, sectionId, index });
  }, [index, newTaskId, onCreateTask, sectionId]);

  return (
    <Box
      spaceBottom="large"
      spaceTop="medium"
      style={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        marginHorizontal: -listContentStyle.paddingHorizontal,
      }}
    >
      {onOrderTasks ? (
        <>
          <ItemButton onPress={onPressOrderTasks}>
            <AHIcon type="reorder" color="primary" spaceRight="xsmall" />
            <ItemButtonTitle>
              <FormattedMessage
                defaultMessage="Reorder"
                description="RoutineEditChecklistSectionFooter reorder tasks button"
              />
            </ItemButtonTitle>
          </ItemButton>
        </>
      ) : null}
      {onAddExistingTask ? (
        <>
          <ItemButton onPress={onPresAddExistingTask}>
            <AHIcon type="add" color="primary" spaceRight="xsmall" />
            <ListItem.Title color="primary">
              <FormattedMessage
                defaultMessage="Existing"
                description="RoutineEditChecklistSectionFooter add existing task button"
              />
            </ListItem.Title>
          </ItemButton>
        </>
      ) : null}
      <ItemButton tabbable onPress={onPressCreateTask}>
        <AHIcon type="add" color="primary" spaceRight="xsmall" />
        <ListItem.Title color="primary">{intl_tokens.Task}</ListItem.Title>
      </ItemButton>
    </Box>
  );
};
